module.exports = {
  platform: 'voice',
  name: 'Return VXML',
  node: 'return_vxml',
  bg: '#FFFFFF',
  note: '',
  property: {
    payload:
      '{"last-intent" : $session.last-intent, "vdn":$contact.in-hour-number}'
  }
}
